import Vue from 'vue'
import VeRing from 'v-charts/lib/ring.common'
import VeLine from 'v-charts/lib/line.common'
import App from './App.vue'
import router from './router'
import store from './store/index'
import {el, $elm} from './plugins/element.js'
import filters from './filters/index'
import components from './components/index'

Vue.config.productionTip = false
el.forEach(c => Vue.use(c))

Vue.component(VeRing.name, VeRing)
Vue.component(VeLine.name, VeLine)
components.forEach(c => Vue.component(c.name, c))

Object.assign(Vue.prototype, {...$elm})
Object.entries(filters).forEach(f => Vue.filter(...f))

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
